import api from "@/auth/api";

const BASE_URL =
  "/pos/terminals";

async function getTerminals() {
  const response = await api.get(BASE_URL);

  const data = response.data;

  console.log(
    "[POS TERMINALS] Raw API response:",
    data
  );

  const terminals = Array.isArray(data)
    ? data
    : Array.isArray(data?.items)
      ? data.items
      : Array.isArray(data?.data)
        ? data.data
        : Array.isArray(data?.results)
          ? data.results
          : Array.isArray(data?.terminals)
            ? data.terminals
            : [];

  console.log(
    "[POS TERMINALS] Extracted terminals:",
    terminals
  );

  return terminals;
}

async function getTerminal(
  id
) {
  const response =
    await api.get(
      `${BASE_URL}/${id}`
    );

  return response.data;
}

async function createTerminal(
  payload
) {
  const response =
    await api.post(
      BASE_URL,
      payload
    );

  return response.data;
}

async function updateTerminal(
  id,
  payload
) {
  const response =
    await api.put(
      `${BASE_URL}/${id}`,
      payload
    );

  return response.data;
}

async function activateTerminal(
  id
) {
  const response =
    await api.post(
      `${BASE_URL}/${id}/activate`
    );

  return response.data;
}

async function deactivateTerminal(
  id
) {
  const response =
    await api.post(
      `${BASE_URL}/${id}/deactivate`
    );

  return response.data;
}

export default {
  getTerminals,
  getTerminal,
  createTerminal,
  updateTerminal,
  activateTerminal,
  deactivateTerminal
};